(() => {
  const root = window.Shopify?.routes?.root || '/';
  const endpoint = root + 'apps/pyunhanga-membership';
  let active;
  async function sync() {
    try { await fetch(endpoint, {credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(12000)}); }
    catch { /* Retry on the next page or before checkout. */ }
  }
  window.pyunhangaMembership = {
    prepareCheckout(attempt, adapter = null) {
      if (!/^[-a-zA-Z0-9]{16,80}$/.test(attempt || '')) return Promise.resolve();
      if (active) return active;
      active = (async () => {
        try {
          let cart;
          if (adapter) cart = await adapter.read();
          else {
            const cartResponse = await fetch(root + 'cart.js', {credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(8000)});
            if (!cartResponse.ok) return;
            cart = await cartResponse.json();
          }
          const response = await fetch(endpoint + '?' + new URLSearchParams({checkout: '1', cart: cart.token, attempt}), {credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(12000)});
          if (!response.ok) throw Error('unavailable');
          const result = await response.json();
          if (!result.receipt) throw Error('no-receipt');
          if (adapter) {
            await adapter.update({'__ph_membership_receipt__': result.receipt});
            return;
          }
          const saved = await fetch(root + 'cart/update.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({attributes: {'__ph_membership_receipt__': result.receipt}}), signal: AbortSignal.timeout(8000)});
          if (!saved.ok) throw Error('not-saved');
        } catch {
          // Clear a receipt from an earlier login/session. Never prevent purchasing
          // when classification is unavailable; the worker uses "확인필요".
          if (adapter) { await adapter.update({'__ph_membership_receipt__': ''}); return; }
          try { await fetch(root + 'cart/update.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({attributes: {'__ph_membership_receipt__': ''}}), signal: AbortSignal.timeout(5000)}); } catch {}
        }
      })().finally(() => { active = null; });
      return active;
    }
  };
  void sync();
  window.addEventListener('pageshow', event => { if (event.persisted) void sync(); });
})();

